import { render } from "./ContentsComp.vue?vue&type=template&id=f6d4c216&scoped=true"
import script from "./ContentsComp.vue?vue&type=script&lang=js"
export * from "./ContentsComp.vue?vue&type=script&lang=js"

import "./ContentsComp.vue?vue&type=style&index=0&id=f6d4c216&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6d4c216"]])

export default __exports__